import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const sel = "h-9 w-full rounded-md border border-input bg-transparent px-2 text-sm";

const valueOf = (f) => (f.fornitore_id ? `f:${f.fornitore_id}` : f.subappaltatore_id ? `s:${f.subappaltatore_id}` : f.operaio_id ? `o:${f.operaio_id}` : "n");

export const EsecutoreField = ({ tipo, form, set }) => {
  const mdo = tipo === "MANODOPERA";
  const [opts, setOpts] = useState({ fornitori: [], subappaltatori: [], operai: [] });
  const [dips, setDips] = useState([]);
  useEffect(() => {
    const kinds = mdo ? ["subappaltatori", "operai"] : ["fornitori"];
    Promise.all(kinds.map((k) => api.get(`/anagrafiche/${k}`).then((r) => [k, r.data]))).then((xs) => setOpts((o) => ({ ...o, ...Object.fromEntries(xs) })));
  }, [mdo]);
  useEffect(() => {
    if (form.subappaltatore_id) api.get("/dipendenti-subappaltatori", { params: { subappaltatore_id: form.subappaltatore_id } }).then((r) => setDips(r.data));
    else setDips([]);
  }, [form.subappaltatore_id]);
  const onPick = (v) => {
    const [k, id] = v.split(":");
    set({ fornitore_id: k === "f" ? id : null, subappaltatore_id: k === "s" ? id : null, operaio_id: k === "o" ? id : null, dipendente_id: null });
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <Label className="text-xs">{mdo ? "Esecutore" : "Fornitore"}</Label>
        <select className={sel} value={valueOf(form)} onChange={(e) => onPick(e.target.value)} data-testid="reg-esecutore-select">
          <option value="n">Nome libero…</option>
          {opts.fornitori.map((f) => <option key={f.id} value={`f:${f.id}`}>{f.nome}</option>)}
          {mdo && <optgroup label="Subappaltatori">{opts.subappaltatori.map((s) => <option key={s.id} value={`s:${s.id}`}>{s.nome}</option>)}</optgroup>}
          {mdo && <optgroup label="Operai interni">{opts.operai.map((o) => <option key={o.id} value={`o:${o.id}`}>{o.nome}</option>)}</optgroup>}
        </select>
      </div>
      {valueOf(form) === "n" && (
        <div>
          <Label className="text-xs">Nome {mdo ? "esecutore" : "fornitore"}</Label>
          <Input value={form.esecutore_nome || ""} onChange={(e) => set({ esecutore_nome: e.target.value })} data-testid="reg-esecutore-nome" />
        </div>
      )}
      {form.subappaltatore_id && dips.length > 0 && (
        <div>
          <Label className="text-xs">Dipendente (facoltativo)</Label>
          <select className={sel} value={form.dipendente_id || ""} onChange={(e) => set({ dipendente_id: e.target.value || null })} data-testid="reg-dipendente-select">
            <option value="">— Impresa nel suo complesso —</option>
            {dips.map((d) => <option key={d.id} value={d.id}>{d.cognome} {d.nome}</option>)}
          </select>
        </div>
      )}
    </div>
  );
};
